import { render, staticRenderFns } from "./batchRelevance.vue?vue&type=template&id=306f24ac&scoped=true&"
import script from "./batchRelevance.vue?vue&type=script&lang=js&"
export * from "./batchRelevance.vue?vue&type=script&lang=js&"
import style0 from "./batchRelevance.vue?vue&type=style&index=0&id=306f24ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f24ac",
  null
  
)

export default component.exports